<template>
  <div class="inner-page unauth">
    <AppHead title="Unauthorised" />
    <Placeholder 
      message="You do not have the privileges to view this page." 
      :withBackButton="true"
      />
  </div>
</template>

<script>

import Placeholder from "@/Components/Placeholder"
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"

export default {
  components: {
    Placeholder,
    AppHead
  },
  layout: AppLayout,
}

</script>

<style scoped lang="sass">

// .unauth

</style>